import "./subscription-details.scss";
import { Button } from "primereact/button";
import { useNewSubscriptionContext } from "../new-subscription.context";
import { useTransactionStepContext } from "../../transaction/new-transaction/transaction-step.context";
import { useForm } from "react-hook-form";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import React from "react";

export interface InputFormSchema {
  startDate: string | "";
}

export interface SubscriptionDetailsProps {}

export function SubscriptionDetails() {
  const { subscriptionStartDate, setSubscriptionStartDate } =
    useNewSubscriptionContext();

  const { nextStepper, previousStepper } = useTransactionStepContext();

  const { control, handleSubmit, watch } = useForm<InputFormSchema>({
    defaultValues: {
      startDate: subscriptionStartDate ?? "",
    },
  });

  const watchedStartDate = watch("startDate");
  React.useEffect(() => {
    setSubscriptionStartDate(watchedStartDate);
  }, [watchedStartDate]);

  const handleNext = () => {
    if (!watchedStartDate) {
      return;
    }
    nextStepper();
  };

  const isDisabledNext = !watchedStartDate;

  return (
    <div id="SubscriptionDetails" className="subscription-details">
      <div className="flex flex-col">
        <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
          <div className="field">
            <InputDateControl<InputFormSchema>
              control={control}
              name="startDate"
              label="Subscription Start Date"
              className="w-full"
              containerClassName="pb-2 mt-4"
              placeholder="Select start date"
            />
          </div>
        </section>
      </div>

      <div className="flex pt-4 justify-between">
        <Button
          label="Back"
          severity="secondary"
          icon="pi pi-arrow-left"
          onClick={() => previousStepper()}
        />
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          disabled={isDisabledNext}
          onClick={handleNext}
        />
      </div>
    </div>
  );
}

export default SubscriptionDetails;
